import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import dayjs, {Dayjs} from 'dayjs';

import {interval, Subscription} from 'rxjs';
import {SettingsService} from "../../services/settings.service";

@Component({
  selector: 'app-remaining-session-time-button',
  templateUrl: './remaining-session-time-button.component.html',
  styleUrls: ['./remaining-session-time-button.component.scss']
})
export class RemainingSessionTimeButtonComponent implements OnInit, OnDestroy {

  @Input() expirationTime: Dayjs | undefined;

  @Output() expired: EventEmitter<any> = new EventEmitter();
  @Output() extendToken: EventEmitter<any> = new EventEmitter();

  remainingTimeString = '';
  updating = false;
  subscription: Subscription | undefined;

  constructor(private settings: SettingsService) {}

  ngOnInit() {
    // emit value in sequence every 1 second
    const source = interval(1000);
    this.subscription = source.subscribe(() => {
      if (this.expirationTime) {
        if (dayjs().isBefore(this.expirationTime)) {
          this.remainingTimeString = this.expirationTime.fromNow();
          this.updating = false;
        } else {
          this.subscription?.unsubscribe();
          this.expired.emit();
        }
      }
    });
  }

  async extend() {
    if (await this.settings.get('credentials')) {
      this.updating = true;
      this.remainingTimeString = '';
      this.expirationTime = undefined;
    }
    this.extendToken.emit();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
